import { createModalExecutor } from '@organisms/actions/createModalExecutor';
import { DueTimeModeType } from '@/types/DueTimeType';
import { IDueTime } from '@/types/IDueTime';
import { IAddRouteMapProps } from './IAddRouteMapProps';
import { AddRouteMapModal } from './AddRouteMapModal';

export const AddRouteMapExecutor = createModalExecutor<IAddRouteMapProps>({
    modal: AddRouteMapModal,
    defaultModalSize: 'l',
    mapProps: ({ action, rowData, modalSize, completeHandler }) => ({
        actionKey: action.key,
        activityKey: action.options?.activityKey,
        processKey: action.options?.processKey,
        documentKey: action.options?.documentKey,
        modalSize,
        levelKey: action.options?.levelKey ?? '',
        nextlevelKey: action.options?.nextlevelKey ?? '',
        abookOptions: action.options?.abookOptions ?? [],
        prefilledComment: action.options?.prefilledComment ?? '',
        defaultDueTime:
            action.options?.defaultDueTime ?? ({ type: DueTimeModeType[DueTimeModeType.Indefinite] } as IDueTime),
        completeHandler,
        rowData: rowData,
    }),
});
